import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import { Button } from 'src/components/shared/Button'
import { getAiDocumentReviewConfigsSaving } from 'src/selectors/aiDocumentReviewConfig'

interface Props {
  formId: string
  isEdit: boolean
}

/**
 * The modal footer's submit. `CommonModal` portals the footer out of the `<Form>` element but
 * keeps it inside the Formik provider, so this submits by `form` id.
 */
const AiReviewConfigSubmitButtonComponent = ({ formId, isEdit }: Props) => {
  const isSaving = useSelector(getAiDocumentReviewConfigsSaving)

  return (
    <Button
      size="small"
      color="dark"
      type="submit"
      form={formId}
      loading={isSaving}
      disabled={isSaving}
      data-testid="ai-review-config-submit-button"
    >
      {isEdit ? 'Save changes' : 'Create'}
    </Button>
  )
}

export const AiReviewConfigSubmitButton = memo(AiReviewConfigSubmitButtonComponent)
